module.exports = __webpack_public_path__ + "static/media/smiley.074ea167.png";